import { render, staticRenderFns } from "./PlayGuide.vue?vue&type=template&id=c050ab94&scoped=true&"
import script from "./PlayGuide.vue?vue&type=script&lang=js&"
export * from "./PlayGuide.vue?vue&type=script&lang=js&"
import style0 from "./PlayGuide.vue?vue&type=style&index=0&id=c050ab94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c050ab94",
  null
  
)

export default component.exports